import Table from '../../../components/table/table';
import { corporateStructureData } from '../../../types/interfaces';
import { formatCurrency } from '../../../utils/Masks';
import Span from '../../../components/texts/span/Span';
import { useConfig } from '../../../context/ConfigContext';

interface PartnersProps {
  partners: corporateStructureData[];
}

const SummmaryPartners: React.FC<PartnersProps> = ({ partners }) => {
  const config = useConfig();
  const isUruguayEnabled = config.isUruguayEnabled ?? false;

  const tableData = {
    size: partners.length,
    totalElements: partners.length,
  };

  const columns = [
    {
      name: 'Nombre',
      selector: (row: any) => (
        <Span type='3' variant='neutral'>
          {row.first_name}
        </Span>
      ),
      grow: 1,
    },
    {
      name: isUruguayEnabled ? 'Cédula' : 'Documento',
      selector: (row: any) => (
        <Span type='3' variant='neutral'>
          {row.ci}
        </Span>
      ),
      grow: 0.5,
    },
    {
      name: 'Cargo',
      selector: (row: any) => (
        <Span type='6' variant='neutral'>
          {row.position}
        </Span>
      ),
      grow: 0.4,
    },
    {
      name: 'Participación',
      selector: (row: any) => (
        <Span type='3' variant='neutral'>
          {row.ownership_interest != null && row.ownership_interest !== ''
            ? `${String(row.ownership_interest).replace(/%$/, '')}%`
            : '-'}
        </Span>
      ),
      grow: 0.5,
    },
    ...(!isUruguayEnabled
      ? [
          {
            name: 'Bienes',
            selector: (row: any) => (
              <Span type='3' variant='neutral'>
                {row.assets}
              </Span>
            ),
            grow: 0.8,
          },
          {
            name: 'Valor',
            selector: (row: any) => (
              <Span type='3' variant='neutral'>
                $ {formatCurrency(row.value ?? 0, true)}
              </Span>
            ),
            grow: 0.7,
          },
        ]
      : []),
  ];

  return (
    <Table
      columns={columns}
      data={partners}
      tableData={tableData}
      variant='weak'
    />
  );
};

export default SummmaryPartners;
